import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { closeDrawer } from '../../features/drawersSlice';
import { Collapsible } from '../common/collapsible';
import { toggle as toggleReviewsDrawer } from '../../features/ReviewsSlice';
export const RatingsSection = ({ title }) => {
    const reviews = useSelector((state) => state.reviews);
    const dispatch = useDispatch();
    return (
        reviews?.reviews.length > 0 && (
            <div className="ab-body-sidebar-section">
                <Collapsible title={title} open>
                    <div
                        className="ab-section-body ab-score-summary"
                        onClick={(event) => {
                            event.stopPropagation();
                            dispatch(
                                closeDrawer({
                                    drawerId: 'BigBookingWidgetDrawer',
                                })
                            );
                            dispatch(toggleReviewsDrawer());
                        }}
                    >
                        <div className="ab-score-section">
                            <div className="ab-score">
                                {reviews?.guestScore}
                            </div>
                            <div>
                                <div style={{ fontWeight: 600 }}>
                                    {reviews?.guestScoreValueText}
                                </div>
                                <div>{reviews?.totalReviewsText}</div>
                            </div>
                        </div>

                        {reviews?.channelScores.map((channel, index) => {
                            return (
                                <div
                                    className="ab-channel-price-container"
                                    key={index}
                                >
                                    <div className="ab-channel-text">
                                        <img
                                            src={channel.channelImage}
                                            style={{ width: '20px' }}
                                        />
                                        {channel.channelName}
                                    </div>
                                    <div>
                                        {channel.channelScore}
                                        {channel.channelScoreOutOf.length <
                                        3 ? (
                                            <span>
                                                {channel.channelScoreOutOf}{' '}
                                                &nbsp;
                                            </span>
                                        ) : (
                                            channel.channelScoreOutOf
                                        )}
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </Collapsible>
            </div>
        )
    );
};

RatingsSection.propTypes = {
    title: PropTypes.string,
};
